import styled from "styled-components";

export const NotFound = styled.h2`
  margin: auto;
  width: 100%;
  height: 100%;
  min-height: 65vh;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
`;
